<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- Chart Area -->
      <vc-donut has-legend :total="100" :start-angle="0" :sections="sections">Total Students (<b>{{data.total_students}}</b>)</vc-donut>
    </div>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
<!--          <h5 class="font-weight-bold mb-0">{{ data }}</h5>-->
          <a-table
          :columns="cols"
          :data-source="tabledata"
          :pagination="false"
          :scroll="{ x: '100%' }"
          >
            <template slot="date"></template>
            <template slot="payment_status" slot-scope="payment_status">
              <a-tag :color="payment_status === 'Paid'? 'blue': 'red'">{{ payment_status }}</a-tag>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const cols = [
  {
    title: 'Name',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Code',
    dataIndex: 'code',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: 'Roll No',
    dataIndex: 'roll_no',
    scopedSlots: { customRender: 'roll_no' },
  },
  /* {
      title: 'Fee',
      dataIndex: 'fee_name',
      scopedSlots: { customRender: 'fee_name' },
    }, */
  {
    title: 'Amount',
    dataIndex: 'amount',
    scopedSlots: { customRender: 'amount' },
  },
  {
    title: 'Status',
    dataIndex: 'payment_status',
    scopedSlots: { customRender: 'payment_status' },
  },
  {
    title: 'Date',
    dataIndex: 'payment_date',
    scopedSlots: { customRender: 'payment_date' },
  },
]

export default {
  name: 'studentsFeeSummary',
  props: ['loading', 'data'],
  data: function() {
    return {
      tabledata: [],
      cols,
      sections: [{ label: 'Unpaid', value: 0 }, { label: 'Paid', value: 0 }],
    }
  },
  watch: {
    data(newVal, oldVal) {
      let labelUnpaid = `Unpaid (${newVal.unpaid_count})`
      let labelPaid = `Paid (${newVal.paid_count})`
      this.sections = [ { label: labelUnpaid, value: (newVal.unpaid_count * 100) / newVal.total_students },
        { label: labelPaid, value: (newVal.paid_count * 100) / newVal.total_students } ]
      this.tabledata = newVal.students_fees.data.map(function(e) {
        return {
          name: e.first_name + ' ' + e.last_name,
          code: e.student_code,
          roll_no: e.roll_no,
          // fee_name: 'hello',
          amount: e.amount,
          payment_status: e.payment_status === 1 ? 'Paid' : 'Unpaid',
          payment_date: e.payment_date,
        }
      })
    },
  },
  /* updated: function () {
    console.log(this.data.students_fees.length)
    this.tabledata = this.data.students_fees.map(function(e) {
      console.log(e)
      return {
        name: e.name,
        roll_no: e.roll_no,
        fee_name: 'hello',
        amount: e.amount,
        payment_status: e.payment_status,
        payment_date: e.payment_date,
      }
    })
  }, */
  /* mounted: function() {

    let param = this.$route.params.day
    this.$http.get(`/api/staff/attendance/report/daily?start_date=${param}&end_date=${param}`).then((data) => {
      // console.log(data.data)
      this.attendance = { absent: data.data.data.total_absent, present: data.data.data.total_present, totalstaff: data.data.data.total_staff, data: data.data.data.attendance }
      let labelabsent = `Absent (${this.attendance.absent})`
      let labelpresent = `Present (${this.attendance.present})`
      this.sections = [ { label: labelabsent, value: this.attendance.absent * 100 / this.attendance.totalstaff },
        { label: labelpresent, value: this.attendance.present * 100 / this.attendance.totalstaff } ]
      this.data = this.attendance.data.map(function(e) {
        return { date: e.date != null ? e.date : '-', staff_id: e.system_staff_id, name: e.first_name + ' ' + e.last_name, in: e.start_time != null ? e.start_time : '-', out: e.end_time === null ? '-' : e.end_time, status: e.start_time != null ? 'Present' : 'Absent' }
        // console.log(e)
      })
      // console.log('this.data', this.data)
      // console.log(this.attendance)
    })
      .catch((err) => {
        console.log(err)
      })
  }, */
  methods: {
    handleBack: function() {
      this.$emit('onBack', 'index')
    },
  },
}
</script>

<style>

</style>
